import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
export const NotificationBadge = ({ number, className, small, children,
// color = "primary",
 }) => (_jsxs("div", Object.assign({ className: "iui-badge-parent" }, { children: [children, !!number && number > 0 && (_jsx("div", Object.assign({ className: clsx("iui-badge primary", className, { small }) }, { children: number > 99 ? "99+" : number })))] })));
